<div class="main-container">

  <div class="superior">
    <div>
      <h2 mat-dialog-title class="title-dialog"> {{ "subirManuales" | translate }} </h2>
      <p>{{ "mensajeSubirManualPrimerParrafo" | translate }}</p>
      <p>{{ "mensajeSubirManualSegundoParrafo" | translate }}</p>
    </div>
    <div class="cerrar">
      <mat-icon color="warn" matTooltip="{{ 'cancelar' | translate }}" mat-dialog-close>
        close
      </mat-icon>
    </div>
  </div>

  <form enctype="multipart/form-data" class="form-column">

    @for (lang of languages; track lang) {
      <mat-form-field appearance="outline" class="input-file-idioma">
        <mat-label>{{ lang.label | translate }}</mat-label>
        <input matInput readonly [formControl]="lang.control" />
        <button matSuffix mat-icon-button (click)="fileInput.click()">
          <mat-icon>upload_file</mat-icon>
        </button>
      </mat-form-field>
      <input #fileInput hidden type="file" accept="application/pdf" (change)="onSubmit($event, lang)" />
    }

  </form>

  <div class="footer2">
    <button mat-raised-button color="primary" [disabled]="isDisabled" (click)="onConfirm()">
      {{ "guardar" | translate }}
    </button>
  </div>

</div>